<div class="modal-header">
  <h5 class="modal-title" id="editUserLabel">Smtp</h5>
  <button type="button" class="close" (click)="cancelClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'host' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.host"  class="form-control">
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'User' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.user"  class="form-control">
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'Password' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.password"  class="form-control">
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'Port' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.port"  class="form-control">
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'Ssl' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.ssl"  class="form-control">
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'Protocol' | translate}}:</label>
      <input type="text" name="referente" required [(ngModel)]="item.protocol"  class="form-control">
    </div>
    <div class="col-lg-3">
      <ng-multiselect-dropdown [settings]="dropdownSettings" placeholder="TipoTask"  [data]="Tipi"
                               [(ngModel)]="Tipo"  >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-lg-3" >
      <label class="mb-0 text-dark control-label col-form-label">{{'Enabled' | translate}}:</label>
      <input type="checkbox" name="referente" required [(ngModel)]="item.enabled"  class="form-control">
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">
  <button type="submit"  (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> {{'RMA.save' | translate}} </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
